import { useSelector } from 'react-redux';

export default function Pagination({ paginate }) {
  const {
    transactions,
    isLoading,
    isError,
    error,
    currentPage,
    transactionPerPage,
  } = useSelector((state) => state.transaction);
  const totalTransitions = transactions.length;

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalTransitions / transactionPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <section style={{ paddingTop: '40px' }} className="pt-12">
      <div
        style={{
          maxWidth: '500px',
          marginInline: 'auto',
          display: 'flex',
          justifyContent: 'end',
          paddingBlock: '30px',
        }}
        className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end"
      >
        {pageNumbers.map((number) => (
          <div
            style={{
              paddingInline: '10px',
              backgroundColor: 'blue',
              color: 'white',
              paddingBlock: '10px',
              marginInline: '5px',
              borderRadius: '10px',
              cursor: 'pointer',
            }}
            onClick={() => paginate(number)}
            className="bg-blue-300 text-white px-4 py-1 rounded-full"
            key={number}
          >
            <p>{number}</p>
          </div>
        ))}
        {/* <div
          style={{
            backgroundColor: 'blue',
            color: 'white',
            paddingInline: '10px',
            borderRadius: '30px',
          }}
          className="bg-blue-600 text-white px-4 py-1 rounded-full"
        >
          1
        </div>
        <div className="bg-blue-100 text-blue-600 px-4 py-1 rounded-full">
          2
        </div>
        <div className="bg-blue-100 text-blue-600 px-4 py-1 rounded-full">
          3
        </div>
        <div className="bg-blue-100 text-blue-600 px-4 py-1 rounded-full">
          4
        </div> */}
      </div>
    </section>
  );
}
